module.exports = __webpack_public_path__ + "static/img/gggggg_40.5e2782c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_40.png
// module id = fW3s
// module chunks = 1